<template>
<div class="m-slideshow">
  <transition-group tag="div">

      <div class="m-slideshow__slide" v-for="slide in activeSlides" v-bind:key="slide.id" v-bind:style="{transform: 'translateX(' + slide.pos + '%'}">

	<div class="m-slideshow__text"> {{ slide.text }}</div>

	<img :data-src="slide.src" :data-srcset="slide.srcset" class="m-slideshow__image lazyload"/>

      </div>

    </transition-group>
  
  <div class="m-slideshow__left" v-on:click="index -= 1">
  </div>

  <div class="m-slideshow__right" v-on:click="index += 1">
  </div>



</div>
</template>

<script>
export default {
    name: "main-content",
    props: ['initialSlides'],
    data: function() {
	return {
	    slideShow: this.initialSlides,
	    activeSlides: [],
	    index: 0
	};
    },
    methods: {
	range: (start, end) =>
	    Array.from(Array(end - start + 1), (_, i) => start + i)
    },
    watch: {
	index: {
	    immediate: true,
	    handler: function (currentIndex) {
		this.activeSlides = this
		    .range(currentIndex - 2, currentIndex + 2)
		    .map((slideIndex) => {
			let indexModulus = slideIndex % this.slideShow.length;
			let slide;
			if (indexModulus < 0) {
			    slide = {... this.slideShow[this.slideShow.length + indexModulus]};			    
			} else {
			    slide = {... this.slideShow[indexModulus]};
			}

			slide.pos = (slideIndex - currentIndex) * 100;
			slide.id = slideIndex;
			return slide;
		    });
	    }
	}
    }
}
</script>
